<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Plan and Billing</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Plan and Billing</li>
          <li class="breadcrumb-item active" aria-current="page">Plan</li>
        </ol>
      </nav>
    </div>
    <div class="head-icons ms-2 d-none">
      <a
        href="javascript:void(0);"
        class=""
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-original-title="Collapse"
        id="collapse-header"
      >
        <i class="ti ti-chevrons-up"></i>
      </a>
    </div>
  </div>
  <!-- /Breadcrumb -->
  <div class="row">
    <div class="col-12 col-lg-10">
      <div class="card border-0">
        <div class="card-header"></div>
        <div class="card-body p-2 mt-1">
          <div class="custom-datatable-filter">
            <div class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Plan:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">{{ plan?.planName }}</p>
            </div>
            <!--<div class="row">
              <p class="col-lg-6 text-lg-end">Price:</p>
              <p class="col-lg-6 fw-bold">
                {{ plan?.planPrice | currency: plan?.planCurrencySymbol : 'symbol' : '1.2-2' }}
                / User
              </p>
            </div>-->
            <div class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Discounted Price:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{
                  plan?.priceAfterDiscount | currency: plan?.planCurrencySymbol : 'symbol' : '1.2-2'
                }}
                / User
              </p>
            </div>
            <div class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Billing Frequency:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ plan?.planType | capitalize }}
              </p>
            </div>
            <div *ngIf="plan?.subscriptionStatus !== SubscriptionStatus.Trialing" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Total Licences:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ plan?.licences?.[0]?.totalLicences }}
              </p>
            </div>
            <div *ngIf="plan?.subscriptionStatus !== SubscriptionStatus.Trialing" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Used Licences:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ plan?.licences?.[0]?.usedLicences }}
              </p>
            </div>
            <div *ngIf="plan?.subscriptionStatus !== SubscriptionStatus.Trialing" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Remaining Licences:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{
                  (plan?.licences?.[0]?.totalLicences ?? 0) -
                    (plan?.licences?.[0]?.usedLicences ?? 0)
                }}
              </p>
            </div>
            <div *ngIf="plan?.licencesForNextCycle" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">
                Total Licences From Next Billing Date:
              </p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ plan?.licencesForNextCycle ?? 0 }}
              </p>
            </div>
            <div *ngIf="plan?.subscriptionStatus === SubscriptionStatus.Trialing" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Minimum Licences:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ plan?.minimumLicences }}
              </p>
            </div>
            <div *ngIf="plan?.subscriptionStatus !== SubscriptionStatus.Trialing" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Recurring Charges:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{
                  plan?.licencesForNextCycle
                    ? ((plan?.licencesForNextCycle ?? 0) * (plan?.priceAfterDiscount ?? 0)
                      | currency: plan?.planCurrencySymbol : 'symbol' : '1.0-0' : 'en-IN')
                    : (plan?.licences?.[0]?.amount
                      | currency: plan?.planCurrencySymbol : 'symbol' : '1.0-0' : 'en-IN')
                }}
              </p>
            </div>
            <div *ngIf="plan?.subscriptionStatus !== SubscriptionStatus.Trialing" class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Next Billing Date:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ plan?.licences?.[0]?.nextBillingDate | date: 'mediumDate' }}
              </p>
            </div>
            <div class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Customer Since:</p>
              <p class="col-6 col-md-6 fw-bold text-end text-md-start">
                {{ customerSince | date: 'mediumDate' }}
              </p>
            </div>
            <div class="row">
              <p class="col-6 col-md-6 text-start text-md-end">Status:</p>

              <p class="col-6 col-md-6 text-end text-md-start">
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-success':
                      plan?.subscriptionStatus?.toLowerCase() ===
                      SubscriptionStatus.Active.toLowerCase(),
                    'bg-primary':
                      plan?.subscriptionStatus?.toLowerCase() ===
                      SubscriptionStatus.Trialing.toLowerCase(),
                    'bg-danger':
                      plan?.subscriptionStatus?.toLowerCase() ===
                        SubscriptionStatus.Cancelled.toLowerCase() ||
                      plan?.subscriptionStatus?.toLowerCase() ===
                        SubscriptionStatus.Expired.toLowerCase()
                  }"
                >
                  {{
                    plan?.subscriptionStatus === SubscriptionStatus.Trialing
                      ? 'Trial'
                      : (plan?.subscriptionStatus | capitalize)
                  }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-2 theiaStickySidebar">
      <div class="card">
        <div class="card-body">
          <!-- <div class="d-flex flex-column list-group settings-list"> -->
          <div class="d-grid">
            <div *ngIf="plan?.subscriptionStatus === SubscriptionStatus.Active" class="mb-3">
              <button
                (click)="openAddModal()"
                class="btn btn-primary w-100"
                type="button"
                *appHasPermission="{ licence: ['add'] }"
              >
                Add Licences
              </button>
            </div>
            <div *ngIf="plan?.subscriptionStatus === SubscriptionStatus.Active" class="mb-3">
              <button
                (click)="openRemoveModal()"
                class="btn btn-primary w-100"
                type="button"
                *appHasPermission="{ licence: ['add'] }"
              >
                Remove Licences
              </button>
            </div>

            <!-- <ng-container
              *ngIf="
                plan?.subscriptionStatus !== SubscriptionStatus.Expired &&
                plan?.subscriptionStatus !== SubscriptionStatus.Cancelled
              "
            > -->
            <button
              (click)="upgradePlan()"
              class="btn btn-primary mb-3"
              type="button"
              *appHasPermission="{ plansAndBilling: ['edit'] }"
            >
              {{
                plan?.subscriptionStatus === SubscriptionStatus.Trialing ||
                plan?.subscriptionStatus === 'pending_activation'
                  ? 'Activate'
                  : 'Upgrade'
              }}
            </button>
            <!-- </ng-container> -->

            <ng-container
              *ngIf="
                plan?.subscriptionStatus === SubscriptionStatus.Expired ||
                plan?.subscriptionStatus === SubscriptionStatus.Cancelled
              "
            >
              <button
                (click)="renewPlan()"
                class="btn btn-primary"
                type="button"
                *appHasPermission="{ plansAndBilling: ['edit'] }"
              >
                Renew
              </button>
            </ng-container>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Licences -->
<ng-template #addLicenceModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Licences</h4>
    <button
      (click)="closeModal()"
      type="button"
      class="btn-close custom-btn-close"
      aria-label="Close"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="addForm">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <p class="mb-3">
            Total Licences:
            <span class="fw-bold">{{ (subscription$ | async).licences?.[0]?.totalLicences }}</span>
          </p>
          <p class="mb-3">
            Used Licences:
            <span class="fw-bold">{{ (subscription$ | async).licences?.[0]?.usedLicences }}</span>
          </p>
          <p class="mb-3">
            Remaining Licences:
            <span class="fw-bold">{{
              (subscription$ | async).licences?.[0]?.totalLicences -
                (subscription$ | async).licences?.[0]?.usedLicences
            }}</span>
          </p>
          <p class="mb-3">
            Updated Licences:
            <span class="fw-bold">{{ totalLicences + addForm.value.addedLicences }}</span>
          </p>
          <div class="mb-3">
            <label for="name" class="form-label"
              >Add Licences<span class="text-danger"> *</span></label
            >
            <input
              type="number"
              id="name"
              class="form-control"
              formControlName="addedLicences"
              (input)="enforceLimit($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        (click)="addLicence()"
        type="submit"
        class="btn btn-primary"
        [disabled]="addForm.invalid"
      >
        Add Licences
      </button>
    </div>
  </form>
</ng-template>
<!-- /Add Licences -->

<!-- Remove Licences -->
<ng-template #removeLicencesModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Remove Licences</h4>
    <button
      (click)="closeModal()"
      type="button"
      class="btn-close custom-btn-close"
      aria-label="Close"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="removeForm">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <p class="mb-3">
            Total Licences:
            <span class="fw-bold">{{ (subscription$ | async).licences?.[0]?.totalLicences }}</span>
          </p>
          <p class="mb-3">
            Used Licences:
            <span class="fw-bold">{{ (subscription$ | async).licences?.[0]?.usedLicences }}</span>
          </p>
          <p class="mb-3">
            Remaining Licences:
            <span class="fw-bold">{{
              (subscription$ | async).licences?.[0]?.totalLicences -
                (subscription$ | async).licences?.[0]?.usedLicences
            }}</span>
          </p>
          <p class="mb-3">
            Licences After Removal:
            <span class="fw-bold">{{
              (subscription$ | async).licences?.[0]?.totalLicences -
                (removeForm.value.removedLicences || 0)
            }}</span>
          </p>
          <div class="mb-3">
            <label for="name" class="form-label"
              >Remove Licences<span class="text-danger"> *</span></label
            >
            <input type="number" id="name" class="form-control" formControlName="removedLicences" />
            <small
              class="text-danger"
              *ngIf="removeForm.get('removedLicences')?.hasError('maxRemaining')"
            >
              Remove Licences cannot be greater than Remaining Licences.
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        (click)="removeLicences()"
        type="submit"
        class="btn btn-primary"
        [disabled]="removeForm.invalid"
      >
        Remove Licences
      </button>
    </div>
  </form>
</ng-template>
<!-- /Remove Licences -->
